import {
  Button,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Option,
  Select,
  Stack,
  Typography,
} from "@mui/joy";
import Logo from "assets/academix-logo-word.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useSignInForm from "./utils/useSignInForm";
import { Link } from "react-router-dom";
import { SIGN_UP_ROUTE, RESET_PASSWORD_ROUTE } from "app/constants/route";
import ForcePasswordChangeForm from "../ForcePasswordChangeForm/ForcePasswordChangeForm";

const SignInForm = () => {
  const {
    isLoading,
    formValue,
    updateFormValue,
    onSubmit,
    showPassword,
    setShowPassword,
    requiresNewPassword,
  } = useSignInForm({});

  // If user needs to change password, show the force password change form
  if (requiresNewPassword) {
    return <ForcePasswordChangeForm username={formValue.username} />;
  }

  return (
    <Stack spacing={2} sx={{ justifyContent: "start", width: 1 }}>
      <Stack
        direction={{ md: "row" }}
        spacing={2}
        alignItems={{ xs: "center", md: "end" }}
      >
        <Typography level="h1" sx={{ lineHeight: 1 }}>
          Welcome to
        </Typography>
        <img
          src={Logo}
          style={{
            width: "190px",
            maxWidth: "90vw",
            height: "fit-content",
            objectFit: "contain",
          }}
        />
      </Stack>
      <Typography level="body-md" textAlign={{ xs: "center", md: "left" }}>
        🚀 Start Your Learning Adventure!
      </Typography>
      <Stack spacing={2} sx={{ pt: 1 }}>
        <form onSubmit={onSubmit} style={{ gap: "1rem", display: "grid" }}>
          <FormControl required>
            <FormLabel>Email</FormLabel>
            <Input
              type="text"
              name="username"
              placeholder="Email"
              value={formValue.username}
              onChange={(e) => updateFormValue("username", e.target.value)}
            />
          </FormControl>

          <FormControl required>
            <FormLabel>Password</FormLabel>
            <Input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formValue.password}
              onChange={(e) => updateFormValue("password", e.target.value)}
              endDecorator={
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              }
            />
          </FormControl>

          <Stack alignItems="flex-end">
            <Link to={RESET_PASSWORD_ROUTE}>
              <Typography level="body-sm" color="primary">
                Forgot Password?
              </Typography>
            </Link>
          </Stack>

          <Stack gap={4} sx={{ mt: 2 }}>
            <Button type="submit" loading={isLoading} fullWidth size="lg">
              Sign In
            </Button>
          </Stack>
          <Stack
            gap={1}
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography level="body-sm">Create an account</Typography>
            <Link to={SIGN_UP_ROUTE}>
              <Typography level="body-sm" color="primary">
                Sign Up Now!
              </Typography>
            </Link>
          </Stack>
        </form>
      </Stack>
    </Stack>
  );
};

export default SignInForm;
